
import * as types from "./actionTypes";
import loginApi from "../api/loginApi";
import * as ajax from "./ajaxCounterActions";
import * as exception from "./exceptionActions";
import { showToastrError } from "../util/toastr";

function _initialiseLoginSession(loginModel) {
    return {
        type: types.ACTIVE_ONDERNEMING_SET,
        body: loginModel
    };
}


export function initialiseLoginSession(forcedGebruikersnaam, forcedPoId, forcedEmail) {
    return function (dispatch) {
        dispatch(ajax.started());
        return loginApi.get(forcedGebruikersnaam, forcedPoId, forcedEmail)
            .then((response) => {
                dispatch(ajax.ended());
                dispatch(_initialiseLoginSession(response.data));
            })
            .catch(error => {
                //todo refactor this
                dispatch(ajax.failed());
                showToastrError("No Authentication Header Info");
                dispatch(exception.throwException(error));
            });
    };
}